import { render, staticRenderFns } from "./HorizontalNavMenuItems.vue?vue&type=template&id=232bcfb8"
import script from "./HorizontalNavMenuItems.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports